import firebase from "src/firebase";

var provider = new firebase.auth.GithubAuthProvider();

export default provider;
